import React from "react";
import { Row, Col, Checkbox } from "antd";
import {
  InputItem,
  SelectItem as SelectItemComponent,
} from "../../../components/forms/FormItems";
import ChildrenAnimationWrapper from "../../../components/animations/ChildrenAnimationWrapper";
import AnimationChildWrapper from "../../../components/animations/AnimationChildWrapper";
import AutoCompleteItem from "../../../components/forms/AutoCompleteItem";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import { MetaDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import PhoneNumberItem from "../../../components/forms/PhoneNumberItem";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";
import { useIntl } from "react-intl";
import { BranchEmployeesSelect } from "../../../components/forms/AutoCompleteFormItem";
const Contact = (props) => {
  const { onAddContact, addContact, branchId } = props;
  const intl = useIntl();

  const onChange = (e) => {
    onAddContact(e.target.checked);
  };

  return (
    <div style={{ display: "flex", flex: 1, flexDirection: "column" }}>
      <Checkbox
        onChange={onChange}
        checked={addContact}
        style={{ padding: "10px 0" }}
      >
        {intl.formatMessage({
          id: "app.opportunities.add_contact",
        })}
      </Checkbox>
      <ChildrenAnimationWrapper>
        <Row>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={1}>
                  <InputItem
                    name="relatives.first_name"
                    category="patient"
                    required={addContact}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={2}>
                  <InputItem
                    name="relatives.last_name"
                    category="patient"
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>
            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={3}>
                  <AutoCompleteItem
                    name="relatives.city"
                    category="patient"
                    city={true}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={4}>
                  <MetaDataSelect
                    name="relatives.relative_type_id"
                    category="patient"
                    metadataName="relative_types"
                    required={addContact}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={5}>
                  <PhoneNumberItem
                    name="relatives.phone_number"
                    category="patient"
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={6}>
                  <PhoneNumberItem
                    name="relatives.mobile_number"
                    category="patient"
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={7}>
                  <InputItem
                    name="relatives.email"
                    category="patient"
                    email={true}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={8}>
                  <CheckBoxItem
                    name="relatives.approve_email"
                    category="patient"
                    showLabel={true}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={5}>
                  <SelectItemComponent
                    name="relatives.treating_patient"
                    category="patient"
                    yesNo={true}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>

              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={6}>
                  <CheckBoxItem
                    name="relatives.main_contact"
                    category="patient"
                    showLabel={true}
                    disabled={!addContact}
                  />
                </AnimationChildWrapper>
              </div>
            </ResponsiveItemsWrapper>

            <ResponsiveItemsWrapper>
              <div style={{ flex: 1 }}>
                <AnimationChildWrapper itemKey={7}>
                  <BranchEmployeesSelect
                    name="relatives.employee_id"
                    category="patient"
                    getEmployee={branchId !== null}
                    required={false}
                    extraParams={{
                      scopePrefix: `branches/${branchId}/`,
                    }}
                    placeholder={intl.formatMessage({
                      id: "app.forms.patient.relatives.employee_placeholder",
                    })}
                    withId
                  />
                </AnimationChildWrapper>
              </div>

              <div style={{ flex: 1 }}></div>
            </ResponsiveItemsWrapper>
          </Col>
        </Row>
      </ChildrenAnimationWrapper>
    </div>
  );
};

export default Contact;
